// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-1VDum";
var _4 = "inputs-3H31o";
var _5 = "action-20s3K";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "inputs", _5 as "action" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "inputs": _4, "action": _5 }
